// components/Embed/Embed.js
import PropTypes from 'prop-types';

const isUrl = v => typeof v === 'string' && /^https?:\/\//i.test(v);

const iframeFromUrl = url => (
  <div className="embed-16x9">
    <iframe
      src={url}
      title="Embedded media"
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>
);

const Embed = ({ value }) => {
  if (!value) return null;
  
  if (typeof value === 'object') {
    if (value.html) return <div className="embed" dangerouslySetInnerHTML={{ __html: value.html }} />;
    if (value.url) return iframeFromUrl(value.url);
  }
  
  if (typeof value === 'string') {
    if (value.trim().startsWith('<')) return <div className="embed" dangerouslySetInnerHTML={{ __html: value }} />;
    if (isUrl(value)) return iframeFromUrl(value);
  }
  
  return null;
};

Embed.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      html: PropTypes.string,
      url: PropTypes.string,
    }),
  ]),
};

export default Embed;